import {Dom, Loc} from 'main.core';
import {mapState, mapGetters, mapActions} from "ui.vue3.vuex";

import {Filters} from "./filters";
import {ItemsList} from "./items-list";
import {MethodologicalSlider} from "./methodological-slider";
import {SectionsElements} from "./sections-elements";
import {Modal} from "./modal";

import '../main.css';
export const Main =
    {
        data(): object {
            return {
                countPublic: 157,
            }
        },
        components: {
            Filters,
            ItemsList,
            MethodologicalSlider,
            SectionsElements,
            Modal,
        },
        computed: {
            ...mapState('itemsStore', ['totalPublishedDevelopments']),
        },
        beforeMount(): void {
            this.$store.dispatch('filtersStore/getFilters')
            this.$store.dispatch('itemsStore/getItems')
            this.$store.dispatch('itemsStore/getNewItems')
            this.$store.dispatch('itemsStore/getPopularItems')
        },
        // language=Vue
        template: `
          <div>
            <div class="methodological-content">
              <div class="container-fluid">
                <div class="methodological-content__row">
                  <div class="methodological-content__col">
                    <div class="methodological-sliders">
                      <div class="methodological-sliders__title">{{ $Bitrix.Loc.getMessage('TITLE_PUBLIC') }} <b>{{
                        totalPublishedDevelopments }} {{ $Bitrix.Loc.getMessage('TITLE_PUBLIC_ITEM_NAME') }}</b></div>
                      <div class="methodological-sliders__items">
                        <MethodologicalSlider
                            :title="$Bitrix.Loc.getMessage('TITLE_SLIDER_POPULAR')"
                            :typeItem="1"
                        />
                        <MethodologicalSlider
                            :title="$Bitrix.Loc.getMessage('TITLE_SLIDER_NEW')"
                            :typeItem="2"
                        />
                      </div>
                    </div>
                    <Filters/>
                  </div>
                  <div class="methodological-content__col">
                    <div class="methodological-sections">
                      <div class="methodological-sections__elements">
                        <SectionsElements/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ItemsList/>
            <Modal/>
          </div>
        `
    }